export default "__VITE_ASSET__ZJw9pyG7__"